import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CandidateQuestionDto } from "../../../model/exam/candidate-question-dto";
import { Router } from "@angular/router";
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDivider } from "@angular/material/list";
import { MatButton } from "@angular/material/button";
import { NgClass } from "@angular/common";

@Component({
    selector: 'app-sample-section-model',
    templateUrl: './section-modal.component.html',
    styleUrls: ['./section-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDivider, MatButton, NgClass, MatDialogActions]
})
export class SampleSectionModelComponent implements OnInit {
    public questions!: { flagged: CandidateQuestionDto[], nonAttempted: CandidateQuestionDto[] }

    constructor(private router: Router,
        private dialogRef: MatDialogRef<SampleSectionModelComponent>
    ) { }

    public ngOnInit(): void {
        
    }

    public close(): void {
        this.dialogRef.close();
    }

    public navigateSection(): void {
        this.close();
        this.router.navigate(['/sample']);
    }
}